import React, { useEffect, useState } from 'react';
import { TextAlignment } from '../../../enum/EnumRepository';
import { StyledInputComponent } from '../../../dto/StyleCompRepository';

interface HeadlessInputProps {
  type?: string;
  inputName?: string;
  autoComplete?: string;
  value: string | number;
  placeholder: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyBoard?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  StyledInput: StyledInputComponent;
  $alignment?: TextAlignment;
  minLimit?: number;
  maxLimit?: number;
}

const HeadlessInput: React.FC<HeadlessInputProps> = ({
  type,
  inputName,
  autoComplete,
  value,
  placeholder,
  handleChange,
  StyledInput,
  $alignment,
  minLimit,
  maxLimit
}) => {
  // minLimit과 maxLimit을 적용하여 너비 계산
  const [width, setWidth] = useState<string | undefined>(
    minLimit ? `${minLimit}ch` : undefined
  );

  useEffect(() => {
    if (minLimit && maxLimit) {
      const stringValue = String(value);
      const calculatedWidth = Math.max(stringValue.length, minLimit);
      const width = `${Math.min(calculatedWidth, maxLimit)}ch`;
      setWidth(width);
    }
  }, [value, minLimit, maxLimit]);

  return (
    <>
      {width ?
        <StyledInput
          type={type ? type : 'text'}
          name={inputName}
          autoComplete={autoComplete}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          $alignment={$alignment || TextAlignment.CENTER}
          style={{ width }}
        />
        :
        <StyledInput
          type={type ? type : 'text'}
          name={inputName}
          autoComplete={autoComplete}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          $alignment={$alignment || TextAlignment.CENTER}
        />
      }
    </>
  );
};

export default HeadlessInput;
